document.addEventListener('DOMContentLoaded', function () {
  console.log("🛠 Script de fórmula personalizada cargado");

  // Definimos los IDs de las variantes según el número de activos
  const VARIANT_IDS = {
    1: 52435618824524, // Fórmula con 1 activo
    2: 52435427623244, // Fórmula con 2 activos
    3: 52435428344140  // Fórmula con 3 activos
  };

  // Función para enganchar el evento al botón
  function setupButton() {
    const addButton = document.querySelector('.add-formula-button');
    if (!addButton) {
      console.log("❌ Botón aún no encontrado, esperando...");
      return;
    }

    console.log("✅ Botón encontrado, enganchando evento...");

    addButton.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      console.log("🖱️ Click capturado correctamente");

      const serumSelected = document.querySelector('.ficha-serum.selected');
      const activesSelected = document.querySelectorAll('.ficha-activo.selected');

      if (!serumSelected || activesSelected.length === 0) {
        alert("Por favor selecciona 1 sérum y al menos 1 activo.");
        return false;
      }

      const activeCount = activesSelected.length;
      const selectedVariantId = VARIANT_IDS[Math.min(activeCount, 3)];
      console.log("🧬 Variante seleccionada:", selectedVariantId);

      const activosNombres = Array.from(activesSelected).map(item => {
        const heading = item.querySelector('h3, h2, h4, h1');
        return heading ? heading.innerText.trim() : "Activo";
      });

      const payload = {
        items: [{
          id: selectedVariantId,
          quantity: 1,
          properties: {
            "Activos elegidos": activosNombres.join(', ')
          }
        }]
      };

      console.log("📦 Payload a enviar:", payload);

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("✅ Producto añadido al carrito:", data);

        // Redirige al carrito solo si el add.js fue exitoso
        window.location.href = '/cart';

      } catch (error) {
        console.error('❌ Error al añadir producto al carrito:', error);
        alert("Hubo un problema al añadir tu fórmula personalizada. Por favor inténtalo de nuevo.");
      }

      return false;
    }, true); // Capturamos en modo capture
  }

  // Al cargar el DOM, buscamos el botón
  if (document.querySelector('.add-formula-button')) {
    setupButton();
  } else {
    console.log("⌛ Botón no encontrado inicialmente, activando observer...");
    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelector('.add-formula-button')) {
        setupButton();
        obs.disconnect(); // Dejamos de observar cuando lo encontramos
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});